import { api } from '../../DefaultService';
import { IClipEscolaCreateProps, IClipEscolaProps, IClipEscolaUpdateParams } from './types';

const ENDPOINT = '/v1/integrations/clipescola';

export const createClipEscolaIntegrationAsync = async (
  data: IClipEscolaCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllClipEscolaIntegrationsAsync = async (): Promise<
  IClipEscolaProps[]
> => {
  return await api
    .get<IClipEscolaProps[]>(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getClipEscolaIntegrationByIdAsync = async (
  id: number,
): Promise<IClipEscolaProps> => {
  return await api
    .get<IClipEscolaProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateClipEscolaIntegrationAsync = async ({
  id,
  data,
}: IClipEscolaUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteClipEscolaIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
